import React, { useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import {
  Card,
  Divider,
  Button,
  Row,
  Col,
  Space,
  Input,
  Table,
  message,
  Spin,
  Tag,
} from "antd";
import { SearchOutlined, PrinterOutlined } from "@ant-design/icons";
import { PaymentLawyerPdfJs } from "../contractDetail/export/PaymentLawyerPdfJs";
import { PaymentArLawyerPdfjs } from "../contractDetail/export/PaymentArLawyerPdfjs";
import MotionHoc from "../../../utils/MotionHoc";
import { BASE_URL_BEN } from "../../API/apiUrls";

const Main = () => {
  const tk = localStorage.getItem("TOKEN");

  const [isClicked, setIsClicked] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]); // เก็บข้อมูลจาก API
  const [loading, setLoading] = useState(false);

  const currencyFormatOne = (amount) => {
    if (amount) {
      return Number(amount)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else {
      return "0.00";
    }
  };
  // ฟังก์ชันล้างค่าทั้งหมด (ใช้ตอนสลับปุ่ม)
  const resetAll = (type) => {
    setIsClicked(type);
    // setSearchText("");
    setDataSource([]);
  };

  // ฟังก์ชันค้นหาข้อมูล
  const handleSearch = async () => {
    setLoading(true);
    try {
      const finalPayload = {
        CONTNO: searchText,
        printType: isClicked, // ยอดรวม
      };

      const response = await axios.post(
        `${BASE_URL_BEN}/auth/main-bill`,
        finalPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        },
      );

      if (response.data) {
        setDataSource(response.data);
      } else {
        setDataSource([]);
        message.info("ไม่พบข้อมูล");
      }
    } catch (error) {
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = async (record) => {
    console.log("Printing receipt for:", record);
    // // ใส่ Logic การสั่งพิมพ์ตรงนี้
    if (!record?.TMBILL) return message.warning("ไม่พบใบเสร็จ");
    if (isClicked === 1) {
      const finalPayload = {
        TMBILL: record?.TMBILL,
        CONTNO: record?.REFDOCNO,
        PAYFOR: record?.PAYFOR,
      };

      setLoading(true);
      try {
        message.loading({
          content: "กำลังโหลดข้อมูลใบเสร็จ...",
          key: "load_process_print",
        });

        const response = await axios.post(
          `${BASE_URL_BEN}/auth/print-payment-lawyer`,
          finalPayload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tk}`,
            },
          },
        );
        console.log("response print", response.data);
        if (response.status === 200 && response.data) {
          message.success({
            content: "โหลดข้อมูลสำเร็จ",
            key: "load_process_print",
          });

          await PaymentLawyerPdfJs(response.data);
        } else {
          message.warning({
            content: "ไม่พบข้อมูลใบเสร็จ",
            key: "load_process_print",
          });
        }
      } catch (error) {
        console.log("error AR", error);
        message.error({
          content: "เกิดข้อผิดพลาดในการโหลดใบเสร็จ",
          key: "load_process_print",
        });
      } finally {
        setLoading(false);
      }
    } else if (isClicked === 2) {
      const finalPayload = {
        TMBILL: record?.TMBILL,
        CONTNO: record?.REFDOCNO,
      };

      setLoading(true);
      try {
        message.loading({
          content: "กำลังโหลดข้อมูลใบเสร็จ...",
          key: "load_process_ar_print",
        });

        const response = await axios.post(
          `${BASE_URL_BEN}/auth/print-payment-lawyer-ar`,
          finalPayload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tk}`,
            },
          },
        );
        console.log("response print", response.data);
        if (response.status === 200 && response.data) {
          message.success({
            content: "โหลดข้อมูลสำเร็จ",
            key: "load_process_ar_print",
          });

          await PaymentArLawyerPdfjs(response.data);
        } else {
          message.warning({
            content: "ไม่พบข้อมูลใบเสร็จ",
            key: "load_process_ar_print",
          });
        }
      } catch (error) {
        console.log("error AR", error);
        message.error({
          content: "เกิดข้อผิดพลาดในการโหลดใบเสร็จ",
          key: "load_process_ar_print",
        });
      } finally {
        setLoading(false);
      }
    } else {
      return message.warning("ไม่ตรงกับเงื่อนไข");
    }
  };

  // กำหนด Column ของ Table
  const columns = [
    {
      title: "เลขที่ใบเสร็จ",
      dataIndex: "TMBILL",
      key: "TMBILL",
      width: 80,
      align: "center",
    },
    {
      title: "วันที่ใบเสร็จ",
      dataIndex: "TMBILDT",
      key: "TMBILDT",
      align: "center",
      render: (text) => {
        // ตรวจสอบก่อนว่ามีข้อมูลวันที่ส่งมาหรือไม่
        return text ? dayjs(text).format("YYYY-MM-DD") : "-";
      },
    },
    { title: "ชำระด้วย", dataIndex: "PAYTYP", key: "PAYTYP", align: "center" },
    {
      title: "จำนวนเงิน",
      dataIndex: "CHQAMT",
      key: "CHQAMT",
      align: "center",
      render: (text) => currencyFormatOne(text),
    },
    { title: "สถานะ", dataIndex: "FLAG", key: "FLAG", align: "center" },
    {
      title: "วันที่ยกเลิกใบเสร็จ",
      dataIndex: "CANDT",
      key: "CANDT",
      align: "center",
      render: (text) => {
        // ตรวจสอบก่อนว่ามีข้อมูลวันที่ส่งมาหรือไม่
        return (
          <Tag color={text ? "red" : "white"}>
            {" "}
            {text ? dayjs(text).format("YYYY-MM-DD") : null}
          </Tag>
        );
      },
    },
    {
      title: "ผู้อนุมัติ",
      key: "user_display", // เปลี่ยน key ให้สื่อความหมายเพราะเป็นการรวมฟิลด์
      align: "center",
      render: (_, record) => {
        return (
          <Tag color="green">
            {record.CANDT ? record.CANDT_BY : record.INPUT_BY}
          </Tag>
        );
      },
    },
    {
      title: "การจัดการ",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Button
          variant="outlined"
          color="blue"
          icon={<PrinterOutlined />}
          onClick={() => handlePrint(record)}
        >
          พิมพ์ใบเสร็จ
        </Button>
      ),
    },
  ];
  return (
    <Card>
      <Spin spinning={loading} size="large" tip=" Loading... ">
        <Divider orientation={"center"}>
          <b>
            <u>สลับรายการ พิมพ์ใบเสร็จ รับเงิน ทนาย</u>
          </b>
        </Divider>
        <Row justify="center" style={{ marginBottom: 20 }}>
          <Col>
            <Space>
              <Button
                onClick={() => resetAll(1)}
                style={{
                  background: isClicked === 1 ? "#ffcb05" : "white",
                  fontWeight: isClicked === 1 ? "bold" : "normal",
                  borderColor: isClicked === 1 ? "#efa420" : "white",
                }}
              >
                พิมพ์ใบเสร็จ ปกติ
              </Button>
              <Button
                onClick={() => resetAll(2)}
                style={{
                  background: isClicked === 2 ? "#ffcb05" : "white",
                  fontWeight: isClicked === 2 ? "bold" : "normal",
                  borderColor: isClicked === 2 ? "#efa420" : "white",
                }}
              >
                พิมพ์ใบเสร็จ ลูกหนี้อื่นๆ
              </Button>
            </Space>
          </Col>
        </Row>

        {/* ส่วนของการค้นหา */}
        <Row justify="center" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Space.Compact style={{ width: "100%" }}>
              <Input
                placeholder={
                  isClicked === 1
                    ? "ค้นหารายการปกติ..."
                    : "ค้นหาลูกหนี้อื่นๆ..."
                }
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onPressEnter={handleSearch}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
                loading={loading}
                style={{
                  backgroundColor: "#efa420",
                  borderColor: "#efa420",
                  color: "#fff",
                }}
              >
                ค้นหา
              </Button>
            </Space.Compact>
          </Col>
        </Row>

        {/* ส่วนแสดงตารางข้อมูล */}
        <Table
          dataSource={dataSource}
          columns={columns}
          rowKey="TMBILL"
          loading={loading}
          locale={{ emptyText: "ไม่มีข้อมูลรายการ" }}
        />
      </Spin>
    </Card>
  );
};
const MainReprintReceivePayment = MotionHoc(Main);
export default MainReprintReceivePayment;
